var _objectSpread = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectSpread2").default;
var _objectWithoutProperties = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectWithoutProperties").default;
var _excluded = ["class", "staticClass", "style", "staticStyle", "attrs"];
require("core-js/modules/es.array.concat.js");
module.exports = {
  functional: true,
  render: function render(_h, _vm) {
    var _c = _vm._c,
      _v = _vm._v,
      data = _vm.data,
      _vm$children = _vm.children,
      children = _vm$children === void 0 ? [] : _vm$children;
    var classNames = data.class,
      staticClass = data.staticClass,
      style = data.style,
      staticStyle = data.staticStyle,
      _data$attrs = data.attrs,
      attrs = _data$attrs === void 0 ? {} : _data$attrs,
      rest = _objectWithoutProperties(data, _excluded);
    return _c('svg', _objectSpread({
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "width": "20",
        "height": "20",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs)
    }, rest), children.concat([_c('g', {
      attrs: {
        "fill": "none",
        "fill-rule": "evenodd"
      }
    }, [_c('path', {
      attrs: {
        "d": "M10 2.267c2.127 0 4.06.87 5.461 2.272A7.71 7.71 0 0117.733 10a7.643 7.643 0 01-2.22 5.41c-1.483 1.482-3.417 2.323-5.513 2.323a7.71 7.71 0 01-5.461-2.272A7.71 7.71 0 012.267 10c0-2.092.835-4.025 2.22-5.41C5.97 3.109 7.904 2.268 10 2.268z",
        "stroke": "var(--mainColor)",
        "stroke-width": "1.2"
      }
    }), _c('g', {
      attrs: {
        "transform": "translate(7.4 7)",
        "fill": "var(--mainColor)"
      }
    }, [_c('rect', {
      attrs: {
        "width": "1.2",
        "height": "6",
        "rx": ".6"
      }
    }), _c('rect', {
      attrs: {
        "x": "4",
        "width": "1.2",
        "height": "6",
        "rx": ".6"
      }
    })])])]));
  }
};